import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
const TRUSTPILOT_SCRIPT_SRC = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
/**
 * Trustpilot "Review Collector" TrustBox widget.
 *
 * Loads the Trustpilot bootstrap script once (idempotent) and renders the
 * Review Collector box, which invites visitors to leave a review — this grows
 * the review count that ultimately unlocks Google's star rich results.
 *
 * Note: this is a client-side widget and is NOT part of the prerendered HTML.
 * The on-page rating/stars display is handled separately by TrustpilotHeader
 * (which IS prerendered) so crawlers and AI engines still see the rating.
 */
export const TrustpilotReviewCollector = () => {
    const ref = useRef(null);
    useEffect(() => {
        const existing = document.querySelector(`script[src="${TRUSTPILOT_SCRIPT_SRC}"]`);
        const loadWidget = () => {
            const tp = window.Trustpilot;
            if (tp && ref.current) {
                tp.loadFromElement(ref.current, true);
            }
        };
        if (!existing) {
            const script = document.createElement('script');
            script.src = TRUSTPILOT_SCRIPT_SRC;
            script.async = true;
            script.addEventListener('load', loadWidget);
            document.head.appendChild(script);
        }
        else {
            loadWidget();
        }
    }, []);
    return (_jsx(Box, { ref: ref, className: "trustpilot-widget", "data-locale": "en-US", "data-template-id": "56278e9abfbbba0bdcd568bc", "data-businessunit-id": "691679805820b5b0e2dafec1", "data-style-height": "52px", "data-style-width": "100%", "data-token": "d29e4b65-10e2-4013-8df9-b18be19c08a4", children: _jsx("a", { href: "https://www.trustpilot.com/review/stanorai.com", target: "_blank", rel: "noopener noreferrer", children: "Trustpilot" }) }));
};
